// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__VFr6x","wrapper":"style__wrapper__Lout5","logo":"style__logo__51jx3"};